import Box from "@mui/material/Box";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import MonogramSvg from "../../assets/monogram.svg?react";
import {
  interestWidgetContainerSx,
  interestWidgetSx,
  interestWidgetLabelSx,
  interestWidgetTextSx,
  interestWidgetIconWrapperSx,
  interestWidgetIconSx,
} from "./InterestWidget.sx";

export interface InterestWidgetProps {
  onClick?: () => void;
}

export function InterestWidget({ onClick }: InterestWidgetProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      // Default behavior: scroll to contact section or navigate to it
      const contactSection = document.getElementById("contact");
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: "smooth" });
      } else {
        window.location.href = "/#contact";
      }
    }
  };

  return (
    <Box sx={interestWidgetContainerSx}>
      <Box sx={interestWidgetSx} onClick={handleClick}>
        <Box className="interest-widget-label" sx={interestWidgetLabelSx}>
          <Typography sx={interestWidgetTextSx}>Interested?</Typography>
        </Box>
        <Box sx={interestWidgetIconWrapperSx}>
          <SvgIcon
            component={MonogramSvg}
            inheritViewBox
            sx={interestWidgetIconSx}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default InterestWidget;
